<template>
  <div class="p-5">
    <strong>
      <h2 style="color:#0f768b;">Edit Data Game</h2>
    </strong>
    <div class="row">
      <div class="col-lg-8 col-sm-12">
        <div class="card border-0 shadow rounded">
          <form class="form" @submit.prevent="edit()">
            <div class="card-body">
              <b-form-group label="Name Voucher" label-for="input-name">
                <b-form-input
                  id="input-title"
                  v-model="data.name"
                  class="input-field"
                  placeholder="Name Voucher"
                  required
                />
              </b-form-group>
                <b-form-group label="Position" label-for="input-name">
                    <b-form-input 
                      id="input-code" 
                      type="number"
                      class="input-field"
                      placeholder="Position" 
                      required
                      v-model="data.position"
                    />
                </b-form-group>

                <b-form-group label="Priority" label-for="input-name">
                    <b-form-input 
                      id="input-code" 
                      type="number"
                      class="input-field"
                      placeholder="Priority" 
                      required
                      v-model="data.priority"
                    />
                </b-form-group>

                <b-form-group
                    id="fieldset-thumbnail"
                    label-for="input-thumbnail"
                    label="Upload Image Here"
                  >
                    <div v-if="loadingImg">
                      <p class="my-3">
                        <b-spinner
                          style="width: 3rem; height: 3rem;"
                          variant="primary"
                          label="Spinning"
                        ></b-spinner>
                        <br />
                        <span>Uploading....</span>
                      </p>
                    </div>
                    <div v-if="!loadingImg">
                      <b-img
                        thumbnail
                        :src="imagePrize"
                        width="200"
                        class="mt-3"
                      />
                      <b-form-file
                        type="file"
                        @change="changeImage()"
                        accept="image/jpeg, image/png, image/jpg"
                        v-model="imagePrize"
                      />
                    </div>
                  </b-form-group>
            <b-button
                class="btn btn-primary mt-5 ml-5"
                style="background-color:#0f768b"
                type="submit"
                :disabled="loading"
                >{{ loading ? "Editing..." : "Update" }}</b-button
              >
                <a
                  class="btn btn-secondary mt-5 ml-5"
                  style="background-color:#0f768b"
                  type="button"
                  href="https://drive.google.com/drive/folders/1vXiqJHD28E-xQpjfykdUgrnp7077WJUm"
                >
                  Download Template
                </a>
              <router-link to="/prize" :disabled="loading">
                <button
                  class="btn btn-secondary mt-5 ml-5"
                  style="background-color:#0f768b"
                  type="button"
                >
                  Cancel
                </button>
              </router-link>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import placeholder from "@/assets/placeholder.png";
import { API_URL } from "@/const";
import _ from "lodash";
import Compressor from "compressorjs";
export default {
  data() {
    return {
      data: {
        name: "",
        position: "",
        priority: "",
        image: "",
        type: "e-voucher"
      },
      imagePrize: placeholder,
      loadingImg: false,
      loading: false,
    };
  },
  methods: {
    async getData() {
      try {
        const { data } = await this.$http.get(`${API_URL}admGameReward`, {
          headers: {
            Authorization: `Bearer ${this.$cookies.get("jwt")}`
          },
          params: {
            id: this.$route.params.id
          }
        });
        this.imagePrize = data.data.image;
        this.data = data.data;
      } catch (e) {
        console.log(e);
      }
    },
    async edit() {
      try {
        this.loading = true;
        const {
          name,
          priority,
          position,
          image,
          type
        } = this.data;
        const payload = {
          name,
          priority,
          position,
          image,
          type
        };
        const request = await this.$http
          .request({
            method: "PUT",
            url: `${API_URL}admGameReward?id=${this.id}`,
            headers: {
              Authorization: `Bearer ${this.$cookies.get("jwt")}`
            },
            data: payload
          })
          .then(value => {
            if (value.data.success == false) {
              this.$bvModal.msgBoxOk(value.data.msg, {
                title: "Confirmation",
                size: "sm",
                buttonSize: "sm",
                okVariant: "success",
                headerClass: "p-2 border-bottom-0",
                footerClass: "p-2 border-top-0",
                centered: true
              });
            }
            if (value.data.success == true) {
              this.$bvModal
                .msgBoxOk("Data was Edited Successfully", {
                  title: "Confirmation",
                  size: "sm",
                  buttonSize: "sm",
                  okVariant: "success",
                  headerClass: "p-2 border-bottom-0",
                  footerClass: "p-2 border-top-0",
                  centered: true
                })
                .then(response => {
                  this.$router.push(
                      "/prize"
                    );
                });
            }
          })
          .catch(e => {
            alert("Data Edited was falied");
            console.log(e);
          });
        this.loading = false;
      } catch (e) {
        this.loading = false;
        console.log(e);
      }
    },
    readFile: file =>
      new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
      }),
    compressImage(file, onSuccess) {
      new Compressor(file, {
        quality: 0.4,
        width: 500,
        height: 500,
        maxWidth: 600,
        convertSize: 5000000,
        mimeType: "image/jpeg",
        success(result) {
          onSuccess(result);
        },
        error(err) {
          console.log(err.message);
        }
      });
    },
    changeImage(event) {
      if (this.file !== null) {
        this.compressImage(this.file, file => {
          this.uploadImage(file);
          this.data.photos.url = fileName;
          this.onLoaded();
        });
      }
    },
    uploadImage(file) {
      let formData = new FormData();      
      formData.append("fotoUrl", file);
      return this.$http.post(`${API_URL}admGameImage`, formData, {
        headers: { 
            Authorization: `Bearer ${this.$cookies.get("jwt")}`
          }
      });
    }
  },
  created() {
    this.id = this.$route.params.id;
    this.getData();
  },
  watch: {
    imagePrize(file) {
      this.loadingImg = true;
      this.readFile(file)
        .then(result => {
          this.uploadImage(file)
              .then(value => {
                this.loadingImg = false;
                this.imagePrize = value.data.data;
                this.data.image = value.data.data;
              })
              .catch(e => {
                this.loadingImg = false;
                console.log(e);
              });
        })
        .catch(e => {
          this.loadingImg = false;
          console.log(e);
        });
    },
  }
};
</script>
